// Pages for each commercial entity. Each page loads its schema + lookups and
// renders the generic CommercialEntity. Programs and Packages have dedicated pages.
import { useEffect, useState } from "react";
import CommercialEntity from "@/components/CommercialEntity";
import { api } from "@/lib/api";
import {
  SCHEMA_CLIENTS, SCHEMA_BRANDS, SCHEMA_AGENCIES, SCHEMA_CONTACTS,
  SCHEMA_CATEGORIES, SCHEMA_PRODUCTS, SCHEMA_TALENTS,
} from "@/lib/commercialSchemas";

function useLookups(keys = []) {
  const [data, setData] = useState({});
  useEffect(() => {
    let mounted = true;
    const map = {
      clients: "/admin/com/clients",
      brands: "/admin/com/brands",
      agencies: "/admin/com/agencies",
      categories: "/admin/com/categories",
      programs: "/admin/programs",
      com_talents: "/admin/com/talents",
    };
    Promise.all(keys.map(async (k) => [k, await api.get(map[k]).catch(() => [])])).then((entries) => {
      if (!mounted) return;
      const out = {}; entries.forEach(([k, v]) => { out[k] = v; }); setData(out);
    });
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, [keys.join(",")]);
  return data;
}

export function ComClientsPage() {
  return <CommercialEntity schema={SCHEMA_CLIENTS} />;
}
export function ComBrandsPage() {
  const lookups = useLookups(["clients", "agencies"]);
  return <CommercialEntity schema={SCHEMA_BRANDS} lookups={lookups} />;
}
export function ComAgenciesPage() {
  return <CommercialEntity schema={SCHEMA_AGENCIES} />;
}
export function ComContactsPage() {
  const lookups = useLookups(["clients", "agencies", "brands"]);
  return <CommercialEntity schema={SCHEMA_CONTACTS} lookups={lookups} />;
}
export function ComCategoriesPage() {
  return <CommercialEntity schema={SCHEMA_CATEGORIES} />;
}
export function ComProductsPage() {
  const lookups = useLookups(["categories", "programs", "com_talents"]);
  return <CommercialEntity schema={SCHEMA_PRODUCTS} lookups={lookups} />;
}
export function ComTalentsPage() {
  return <CommercialEntity schema={SCHEMA_TALENTS} />;
}
